import { render } from "./excursionDetail.vue?vue&type=template&id=38678588"
import script from "./excursionDetail.vue?vue&type=script&lang=js"
export * from "./excursionDetail.vue?vue&type=script&lang=js"

import "./excursionDetail.vue?vue&type=style&index=0&id=38678588&lang=css"

import exportComponent from "E:\\edu-ui\\BmMuseumAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__